"use client";

import { useEffect } from "react";
import { triggerSideConfetti } from "@/lib/utils";

/**
 * Handles the confetti animation on page load.
 * Shown only on a specific launch date (29.04.2026) and only once per user.
 */
export const PageLoadConfetti = () => {
  useEffect(() => {
    // Target date: 06.05.2026
    const now = new Date();
    const isLaunchDay =
      now.getFullYear() === 2026 &&
      now.getMonth() === 4 && // May is 4 (zero-indexed)
      now.getDate() === 6;

    if (!isLaunchDay) return;

    // Check if the user has already seen the animation using localStorage
    const hasSeenLaunchAnimation = localStorage.getItem(
      "muuuh_launch_animation_seen"
    );

    if (hasSeenLaunchAnimation) return;

    // Small delay to ensure the page has visually loaded
    const timer = setTimeout(() => {
      triggerSideConfetti(3000);
      // Mark as seen so it doesn't show again
      localStorage.setItem("muuuh_launch_animation_seen", "true");
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return null;
};
